import getFeatures from "./helper";
import { useAppContext } from "../../../../CEF/Providers";
import { useCefEventTracker } from "../../../../CEF/Hooks/useCefEventTracker";
import { CefEvent, Platform } from "../../../../../EventTracker";
import { useIsMobile } from "../../../../CEF/Common/useIsMobile";
var Content = function Content(_ref) {
  var openModalFn = _ref.openModalFn,
    result = _ref.result,
    useUpdatedButtonDesign = _ref.useUpdatedButtonDesign,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'contained' : _ref$variant,
    fullWidth = _ref.fullWidth;
  var _useAppContext = useAppContext(),
    userId = _useAppContext.userId,
    programId = _useAppContext.programId;
  var _useCefEventTracker = useCefEventTracker(),
    trackEvent = _useCefEventTracker.trackEvent;
  var isMobile = useIsMobile();
  var onTrack = function onTrack(eventName) {
    trackEvent(CefEvent(eventName, isMobile ? Platform.Mobile : Platform.Desktop));
  };
  var _getFeatures = getFeatures({
      result: result,
      openModalFn: openModalFn,
      userId: userId,
      programId: programId,
      onTrack: onTrack,
      variant: variant,
      fullWidth: fullWidth,
      useUpdatedButtonDesign: useUpdatedButtonDesign
    }),
    button = _getFeatures.button;
  return button;
};
export default Content;